import { AppContext } from "AppContainer";
import Page from "components/Page";
import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import PurchaseOrderDeliverPage from "./PurchaseOrderDeliverPage";
import PurchaseOrderPage from "./PurchaseOrderPage";
import PurchaseOrdersPage from "./PurchaseOrdersPage";

const PurchasePages = () => {
  const { user } = useContext(AppContext);

  if (!user.supplier.enablePurchaseOrder)
    return (
      <Page title="Orders 订单">
        <div className="p-10">
          订单功能正在内测中，如果您想体验或者了解更多信息，请联系我们。
        </div>
      </Page>
    );

  return (
    <Routes>
      <Route index element={<PurchaseOrdersPage />} />
      <Route path=":odooCompanyId/:id" element={<PurchaseOrderPage />} />
      <Route
        path=":odooCompanyId/:id/deliver"
        element={<PurchaseOrderDeliverPage />}
      />
    </Routes>
  );
};

export default PurchasePages;
